import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import Keycloak from "keycloak-js";

export const tokenInterceptor: HttpInterceptorFn = (req, next) => {

  const keycloak = inject(Keycloak);
  
  const token = keycloak.token;

  // Definiamo qui la logica di esclusione o inclusione
  const isApiCall = req.url.includes('users-api') || req.url.includes('portale-fornitori');
  const isAuthPath = req.url.includes('/access/');

  if (token && isApiCall && !isAuthPath) {
    const authReq = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      }
    });
    return next(authReq);
  }

  return next(req);
};